// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE


var blue = "#478896";

var green = "#66886E";

var silver = "#C0C0C0";

var black = "#1D2505";

var white = "#FAF1E6";

export {
  blue ,
  green ,
  silver ,
  black ,
  white ,
  
}
/* No side effect */
